/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import {
  FileType,
  isDocumentFile,
  isSpreadsheetFile,
  isVideoFile,
} from '../file-type-utils'
import { DocumentCardHeader } from './document-card-header'
import { ImageCardHeader } from './image-card-header'
import { SpreadsheetCardHeader } from './spreadsheet-card-header'
import { VideoCardHeader } from './video-card-header'

interface CardHeaderProps {
  title: string
  backgroundColor?: string
  sourceUrl: string
  fileType: FileType
  relevanceValue: number
  groupedCards?: any[]
  currentCardIndex: number
  streamLinkWithTimestamp: string | undefined
  onClose: () => void
  onImageExpand: () => void
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  fileType,
  streamLinkWithTimestamp,
  sourceUrl,
  title,
  onImageExpand,
  ...commonProps
}) => {
  const isSpreadsheet = isSpreadsheetFile(title, fileType)
  const isVideo = isVideoFile(fileType)
  const isDocument = isDocumentFile(fileType)

  if (isVideo && streamLinkWithTimestamp) {
    return (
      <VideoCardHeader
        {...commonProps}
        title={title}
        streamLinkWithTimestamp={streamLinkWithTimestamp}
      />
    )
  }

  if (isSpreadsheet) {
    return (
      <SpreadsheetCardHeader
        {...commonProps}
        title={title}
        onImageExpand={onImageExpand}
      />
    )
  }

  if (isDocument) {
    return (
      <DocumentCardHeader
        {...commonProps}
        title={title}
        sourceUrl={sourceUrl}
      />
    )
  }

  return (
    <ImageCardHeader
      {...commonProps}
      title={title}
      sourceUrl={sourceUrl}
      onImageExpand={onImageExpand}
    />
  )
}
